module.exports = __webpack_public_path__ + "static/level-0-logo.70868bb0.png";